import React, { useMemo } from "react";
import { InstagramHeader } from "../../InstagramHeader";
import { InstagramItems } from "../../InstagramItems";
import { InstagramItemsEmbedThumbnail } from "./InstagramItemsEmbedThumbnail";
export function SliceInstagramPosts(_ref) {
  var primary = _ref.primary,
      fields = _ref.fields,
      label = _ref.label;
  var postUrls = useMemo(function () {
    return fields === null || fields === void 0 ? void 0 : fields.map(function (f) {
      var _f$instagram_link;

      return f === null || f === void 0 ? void 0 : (_f$instagram_link = f.instagram_link) === null || _f$instagram_link === void 0 ? void 0 : _f$instagram_link.url;
    });
  }, [fields === null || fields === void 0 ? void 0 : fields.map]);
  return React.createElement("div", {
    className: "instagram-container"
  }, React.createElement("div", {
    className: "container padding-left"
  }, React.createElement(InstagramHeader, primary), label === "embed" ? React.createElement(InstagramItems, {
    postUrls: postUrls
  }) : React.createElement(InstagramItemsEmbedThumbnail, {
    postUrls: postUrls
  })));
}
SliceInstagramPosts.componentName = "instagram_posts";
export default SliceInstagramPosts;